import { PRODUCTS_PARTNER_FILTER_EVENTS } from './global-events';

export const productsPartnerFilterOptions = [
  {
    id: 'all',
    name: 'Вся система',
    event: PRODUCTS_PARTNER_FILTER_EVENTS.PRODUCTS_PARTNER_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    }
  },
];
